module.exports = __webpack_public_path__ + "static/media/signage-indoor-img19.c8f305b3.jpg";